/* globals I18n */
import React from "react";

const filters = {
  alignment: false,
  collision_repair: false,
  diagnostic: false,
  general_repair: false,
  rv: false,
  shuttle: false,
  state_inspections: false,
  synchrony: false,
  tire: false,
  towing: false,
  diesel: false,
  electric: false,
  heavy_duty: false,
  hybrid: false,
  import: false,
  ev_specialist: false,
};

// NOTE: Synchrony is US only
if (I18n.locale !== "en") {
  delete filters.synchrony;
}

const SearchSettings = ({
  query,
  radius,
  handleChange,
  handleSubmit,
  handleFilterChange,
  isLoading
}) => {
  return (
    <div>
      <div className="flex justify-center py-5 gap-2">
        <div className="w-full md:w-1/3">
          <label className="text-gray-700" htmlFor="query">
            {I18n.t("shop_search")}
          </label>
          <input
            id="query"
            className="text-gray-700 h-12 bg-white focus:outline-none focus:shadow-outline border border-brand-gray rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
            placeholder={I18n.t("zip_city_address")}
            value={query}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !isLoading) {
                handleSubmit(e);
              }
            }}
          />
        </div>
        <div className="w-full md:w-1/3">
          <div className="relative">
            <label className="text-gray-700" htmlFor="radius">
              {I18n.t("search_radius")}
            </label>
            <select
              className="select-arrow h-12 block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              id="radius"
              onChange={handleChange}
              value={radius}
            >
              <option>10</option>
              <option>20</option>
              <option>30</option>
              <option>40</option>
              <option>50</option>
            </select>
          </div>
        </div>
        <button
          className="bg-brand-red hover:bg-brand-redhighlight text-sm text-white px-4 rounded self-end h-12 disabled:opacity-60 disabled:cursor-not-allowed"
          type="button"
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? I18n.t("loading") : I18n.t("search")}
        </button>
      </div>
      <div>
        <h2 className="font-sans font-bold text-brand-blue text-xl">
          {I18n.t("filter_by")}:
        </h2>
        <div className="flex flex-row flex-wrap mb-5 gap-6 py-4">
          {Object.entries(filters).map(([key, value]) => (
            <div id={key} key={key} className="text-brand-textgray">
              <label htmlFor={`filter-${key}`}>
                <input
                  id={`filter-${key}`}
                  data-name={key}
                  type="checkbox"
                  defaultChecked={value}
                  onChange={handleFilterChange}
                  className="mr-2"
                />
                {I18n.t(key)}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

SearchSettings.defaultProps = {
  query: "",
  radius: 20,
};

export default SearchSettings;
